import ReactQrCode from 'react-qr-code';
import { OpenInFull } from '@mui/icons-material';
import { theme } from 'assets/themes/zizzi';
import { Wrapper, Header, Footer } from './QRCode.styles';

interface QRCodeProps {
  code: string;
  isAlert?: boolean;
  onClick?: () => void;
}

const QRCode = ({ code, isAlert = false, onClick }: QRCodeProps) => (
  <Wrapper alert={`${isAlert}`} onClick={onClick} aria-label="QR Code Ticket">
    <Header>
      <OpenInFull />
    </Header>
    <Footer>
      <ReactQrCode fgColor={theme.palette.primary.main} size={125} value={code} level="M" />
    </Footer>
  </Wrapper>
);

export default QRCode;
